<tt-card *ngIf="!!get && !!params">
    <tt-input ttLabel="postplace_id" [(ttModel)]="get.postplace_id" [ttReadonly]="params.postplace_id !== '0'"></tt-input>
    <tt-input ttLabel="postplace_name" [(ttModel)]="get.postplace_name"></tt-input>
    <tt-select ttLabel="country" [(ttModel)]="get.country_id" (ttModelChange)="loadMunicipalities()" [ttData]="countries" ttDataId="country_id" ttDataName="country_name"></tt-select>
    <tt-input ttLabel="comunity_id" [(ttModel)]="get.comunity_id"></tt-input>
    <tt-select ttLabel="comunity" [(ttModel)]="get.comunity_id" [ttData]="municipalities" ttDataId="comunity_id" ttDataName="comunity_name"></tt-select>
    <tt-button-save [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
</tt-card>
